import React, { useState } from "react";
import BusinessSubNav from "../../components/Business/BusinessSubNav/BusinessSubNav";
import BusinessTitleSection from "../../components/Business/BusinessTitleSection/BusinessTitleSection";
import { Responsive } from "../../interface/redux/config";
import { useLanguage } from "../../hooks/useLanguage";

type Props = {
  Desktop: Responsive;
  PcTablet: Responsive;
  Mobile: Responsive;
};

const Education = ({ Desktop, PcTablet, Mobile }: Props) => {
  const { isKr } = useLanguage();
  const [NavIndex, setNavIndex] = useState<number | undefined>(undefined);
  const Nav_layout = isKr
    ? ["운용모델", "진행절차", "구축 후 효과"]
    : ["Operation Model", "Process", "Post-Implementation Effects"];
  return (
    <main className="bg-black">
      <BusinessTitleSection
        Desktop={Desktop}
        PcTablet={PcTablet}
        Mobile={Mobile}
        tag={isKr ? "HUCONN BUSINESS | 교육 솔루션" : "HUCONN BUSINESS | Education Solution"}
        title={`EDUCATION
SOLUTION`}
        sub={isKr
          ? `신설학과 및 학과개편 컨설팅,
교육훈련 장비 기획 및 제조, 교육지원`
          : `Consulting for new departments and reorganization,
planning & manufacturing of training equipment, education support`}
        mb={isKr
          ? `신설학과 및 학과개편 컨설팅,
교육훈련 장비 기획 및 제조, 교육지원`
          : `Consulting for new departments and reorganization,
planning & manufacturing of training equipment, education support`}
        bgstyle="pc:bg-edu-title-pc tablet:bg-edu-title-tablet mb:bg-edu-title-mb"
      />
      <BusinessSubNav
        layout={Nav_layout}
        nowNav={NavIndex !== undefined ? NavIndex : 0}
        setNav={setNavIndex}
      />
    </main>
  );
};

export default Education;
